var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6.12h6.67v.97H7.75zM7.75 10.08h6.67v.97H7.75zM17.29 7.41a.83.83 0 0 1-.56-.23.807.807 0 0 1 .56-1.39c.45 0 .81.36.81.81 0 .22-.09.43-.25.58-.15.15-.35.23-.56.23ZM17.29 11.3a.848.848 0 0 1-.81-.81c0-.22.09-.44.25-.59.28-.31.76-.33 1.07-.05l.05.05c.16.15.25.37.25.59-.02.44-.37.79-.81.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.49 2.14-1.65-1.12-1.62 1.12-1.62-1.12-1.65 1.12-1.62-1.12-1.62 1.12-1.62-1.12-1.65 1.12-1.55-1.12v17.13H1.06v2.56c0 .6.23 1.18.65 1.6.42.44 1.01.68 1.62.67h15.45c.61 0 1.2-.23 1.62-.67.43-.42.66-1 .65-1.6V1.02l-1.56 1.12ZM16.5 22.01H3.3c-.34 0-.68-.13-.92-.37-.26-.24-.4-.58-.39-.93v-1.62h14.52v2.93Zm3.61-1.31c0 .35-.13.69-.39.93-.25.25-.6.38-.95.37s-.04 0-.06 0c-.71-.02-1.26-.6-1.25-1.31v-2.56H5.82V2.76h14.3v17.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewOrders);
export default __webpack_public_path__ + "static/media/Overview - Orders.343a9c5388942779e424278fa1a2dd05.svg";
export { ForwardRef as ReactComponent };